<button mat-button [disabled]="pending" (click)="eventClick.emit()">
  {{ pending ? 'Ожидайте' : label }}
</button>
